import { EventsService } from 'src/app/services/event/event.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { LoyaltyProgramProvider } from 'src/app/services/loyalty-program/loyalty-program.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { digitsOnlyValidator } from "src/app/services/customFormValidators";
import { SiteContentService } from "src/app/services/sitecontent/sitecontent.service";
import { SiteContentInterface } from "src/app/interfaces/sitecontent-interface";
import { mustBeTruthy } from 'src/app/services/customFormValidators';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { SidemenuService } from 'src/app/services/sidemenu/sidemenu.service';
import { Platform } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config/config.service';


@Component({
  selector: 'page-loyalty-program',
  templateUrl: './loyalty-program.html',
  styleUrls: ['./loyalty-program.scss'],
})

export class LoyaltyProgramPage implements OnInit{
 
  public error;
  public isConnected: boolean;
  private cardUpdateListener: EventListener;
  public isMaxAttempReached:boolean=false;
  public contactSupportURL: string;

  public loyaltyProgramForm: FormGroup;
  public loyalty_card_id: AbstractControl;
  public loyalty_consent: AbstractControl;
  public labels: any = [];
  

  constructor(
    public appLinks: AppLinksService,
    private loyaltyProgramProvider: LoyaltyProgramProvider,
    private events: EventsService,
    private siteContentService: SiteContentService,
    private successMessageProvider: SuccessMessageService,
    private sidemenuService: SidemenuService,
    private platform: Platform,
      private config: ConfigService,
  ) {

    this.checkLoyaltyProgram();
    this.loyaltyProgramProvider.cardConnectEvent.addListener("Card Status Update", (arg) => this.isConnected = arg);
  }

  private checkLoyaltyProgram(): void {
    this.loyaltyProgramProvider.getLoyaltyCard().subscribe((res) => {
      (res.result == 1 && res.payload == true) ? this.isConnected = true : this.isConnected = false;
    })
  }


  ngAfterViewInit() {
    this.siteContentService.loadConfig('loyalty-rewards') //
      .then((response: SiteContentInterface) => {
        this.labels = response;
      })
  }

  ngOnInit(): void {
    this.contactSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL;
    this.loyaltyProgramForm = new FormGroup(
      {
        loyalty_card_id: new FormControl('', [digitsOnlyValidator, Validators.maxLength(25), Validators.required]),
        loyalty_consent: new FormControl(false, [mustBeTruthy]),

      }
    );

    this.loyalty_card_id = this.loyaltyProgramForm.get('loyalty_card_id');
    this.loyalty_consent = this.loyaltyProgramForm.get('loyalty_consent');

  }

  openMatchedExternalLinks(code, title) {
    return this.appLinks.openMatchedExternalLinksPopover(code, title);
  }

  public onAdd() {
    this.loyaltyProgramProvider.connectLoyaltyCard(this.loyaltyProgramForm.value).subscribe({ next: (response) => {
      if (response.result == 1) {
        this.isConnected = true;
        this.sidemenuService.reIterateMenu();
        this.successMessageProvider.setMessage("Your Momentum Account is now connected");
      }
    }, error: (error) => {
      this.error = error;
      this.isMaxAttempReached=false;
      switch (error.getErrorCode().toUpperCase()) {
        case 'CUSTOMER_NOT_FOUND':
          error.setErrorMessage('Sorry! Invalid reward card');
          break;
        case 'CUSTOMER_ALREADY_ENROLLED':
          error.setErrorMessage('Sorry! Customer already enrolled');
          break;
        case 'CONNECTION_ERROR':
          error.setErrorMessage('Sorry! There was a connection error');
          break;
        case 'MAX_ATTEMPTS_REACHED':
          this.isMaxAttempReached=true
          error.setErrorMessage('The card that you used is invalid. Please contact customer support');
          break;
        default:
          error.setErrorMessage(error.getErrorMessage());
          break;
      }
    }});
  }
  handleSupportNav(){
    return this.appLinks.openExternalPage(this.contactSupportURL);
  }
  handleScrollEnd() {
    // Remove focus from the active element (input field) when the scroll ends
    // This will collapse the keyboard
    if (this.platform.is('mobileweb')) {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
        }
      }
  }
}

